import { Table } from '@shinetools/lumen-react'
import { KeyboardEvent, ReactElement } from 'react'

import { useTransactionView } from '@features/transactions/contexts/transactionViewContext'

import type { LedgerEntryColumnDef } from '../../../../../../hooks/useLedgerEntriesTableColumns'
import type { LedgerEntry } from '../../../../../../types/LedgerEntry'

interface LedgerEntryRowProps {
  columns: LedgerEntryColumnDef[]
  entry: LedgerEntry
}

export const LedgerEntryRow = ({ columns, entry }: LedgerEntryRowProps): ReactElement => {
  const { handleTransactionClick, isOpen, selectedTransaction } = useTransactionView()

  const { transactionId } = entry
  const isSelected = Boolean(transactionId) && isOpen && selectedTransaction?.id === transactionId

  const handleRowClick = (): void => {
    if (transactionId) {
      handleTransactionClick({ id: transactionId })
    }
  }

  const handleRowKeyDown = (event: KeyboardEvent<HTMLTableRowElement>): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleRowClick()
    }
  }

  const cells = columns.map((column) => (
    <Table.Cell key={column.id} align={column.align}>
      {column.Cell(entry)}
    </Table.Cell>
  ))

  if (!transactionId) {
    return <Table.Row highlighted={entry.isOpeningBalance}>{cells}</Table.Row>
  }

  return (
    <Table.Row
      aria-current={isSelected || undefined}
      clickable
      highlighted={entry.isOpeningBalance}
      onClick={handleRowClick}
      onKeyDown={handleRowKeyDown}
      role="button"
      selected={isSelected}
      tabIndex={0}
    >
      {cells}
    </Table.Row>
  )
}
